import React, { useEffect, useRef, useState } from 'react';
import { getRegisterUser } from '../api/orderHistory';

export default function Page1() {
  const [myPayData, setMyPayData] = useState<any>();
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = () => {
    const form = formRef.current;
    if (form) {
      const url = form.action;
      const formData = new FormData(form);
      const newForm = document.createElement('form');
      newForm.method = 'POST';
      newForm.action = url;
      newForm.target = '_blank';
      formData.forEach((value, key) => {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = value.toString();
        newForm.appendChild(hiddenField);
      });
      document.body.appendChild(newForm);
      newForm.submit();
      document.body.removeChild(newForm);
    }
  };

  useEffect(() => {
    getRegisterUser().then((res) => {
      setMyPayData(res.data);
    });
  }, []);
  return (
    <div>
      <div
        style={{
          position: 'relative',
          width: '100%',
          padding: '140px 0',
          textAlign: 'center',
        }}
      >
        <button
          type="button"
          onClick={() => {
            handleSubmit();
          }}
        >
          오픈테스트 버튼
        </button>
      </div>

      <form action={myPayData?.webUrl} method="post" ref={formRef}>
        <input type="hidden" name="birthDay" value={myPayData?.birthDay} />
        <input type="hidden" name="frnYn" value={myPayData?.frnYn} />
        <input type="hidden" name="hCorp" value={myPayData?.hCorp} />
        <input type="hidden" name="mid" value={myPayData?.mid} />
        <input type="hidden" name="returnUrl" value={myPayData?.returnUrl} />
        <input type="hidden" name="signature" value={myPayData?.signature} />
        <input type="hidden" name="socailNo2" value={myPayData?.socailNo2} />
        <input type="hidden" name="userId" value={myPayData?.userId} />
        <input type="hidden" name="userNm" value={myPayData?.userNm} />
      </form>
    </div>
  );
}
